<app-form-tagbsk
    [tagList]="tagList"
    [basketList]="basketList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-tagbsk>
